<template>
    <section class="menu__page padding_menu line-menu" v-if="loaded">
       <div class="item" v-if="menuTop" v-for="menu in menuTop" :key="menu.id">
          <nuxt-link :to="menu.link" class="solid-hover" :class="{'active':isActive(menu.link)}" exact>{{menu.name}}</nuxt-link>
       </div>
    </section>
</template>

<script>
    import RouteMixin from "../shared/mixins/RouteMixin";

    export default {
      mixins: [RouteMixin],

      computed: {
        loaded() {
          return this.$store.state.menu.menuItems.top.loaded
        },
        menuTop() {
          return this.$store.getters['menu/menuTop'](this.urlParent(this.$route.path));
        },

      },
      methods: {
        isActive(url) {
          const parseUrl =  url.split('/');
          if(this.$route.params.category && parseUrl.indexOf(this.$route.params.category) !== -1) {
            return true
          } else if(url && this.$route.path === url) {
            return true
          }
          return false
        }
      },
      watch: {
        menuTop(menuItem) {
          if(menuItem.length) {
            const url = this.urlParentSub(this.$route.path) || null;
            const value = menuItem.find((item)=>item.link === url);
            this.$emit('currentMenu', value);
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// components/products/ProductsMenu.vue